import { useScrollTrigger } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  CSSForFilterDropdown,
  CSSForSelect,
  CSSForSelect15vWWidth,
  CSSForSelect20vWWidth,
  DateRangePicker,
  formatDate,
  handleErrorToast,
  sortProjects,
  uploadFileInChunks,
} from "../CustomFunctions";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { toast, ToastContainer } from "react-toastify";
import {
  AddwithWhiteCircle,
  CircularGrid,
  Employee,
  Filter,
  Location,
  Office,
  ProjectIcon,
  UpdatePencil,
} from "../AllSvg";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { DocumentSection, statesAndUTs } from "../FormdataComponent";
import { DocumentModel } from "./ProjectDetailsCrudButtons";
import * as XLSX from "xlsx";
import { axiosInstance2 } from "../../config/axiosInstance";

const UploadCompanyCredit = ({
  getData,
  getContractorProjects,
  subcompanyList,
}) => {
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});

  const bulktableRef = useRef(null);
  const handleDownload = () => {
    const headers = [
      "project_code",
      "project_name",
      "sub_company",
      "project_short_name",
      "project_type",
      "state",
      "client",
      "project_length",
      "lane",
      "special_structure",
      "participate_as",
      "share_mention_on_clientcertificate",
      "share_asper_certificate",
      "CA_Certificate_available",
      "share_as_per_ca_certificate",
      "project_cost_cr",
      "total_consultancy_fees_cr",
      "completion_date",
      "remark",
    ].filter(Boolean);

    const data = [
      headers,
      [],
      ["REFERENCES:"],
      [],
      ["GENERAL INSTRUCTIONS:"],
      ["   • Project code must be unique."],
      ["   • Project length (in KM): enter only numbers."],
      ["   • Lane: enter only numbers (e.g., 2, 4, 6, 8)."],
      ["   • In share_mention_on_clientcertificate, enter 'true' or 'false'."],
      ["   • In CA_Certificate_available, enter 'true' or 'false'."],
      [
        "   • In share_asper_certificate and share_as_per_ca_certificate, enter numbers (e.g., 50, 60, 70). Do not enter percentages (e.g., 50%).",
      ],
      [
        "   • In project_cost_cr and total_consultancy_fees_cr, enter the cost in crores. For example, if the cost is 5 crores, just type 5.",
      ],

      [],

      [" Company OPTIONS:"],
      ...(Array.isArray(subcompanyList) && subcompanyList.length > 0
        ? subcompanyList.map((r) => [`   • ${r.title}`])
        : []),
      [],
      [" State OPTIONS:"],
      ...(Array.isArray(statesAndUTs) && statesAndUTs.length > 0
        ? statesAndUTs.map((r) => [`   • ${r}`])
        : []),
      [],
      ["NOTE: All Dates should be in DD-MM-YYYY format."],
      [],

      ["Delete all references before uploading."],
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Company Credential Format");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

    const blob = new Blob([s2ab(wbout)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Company Credential Format.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleClose = () => {
    setFileName("");
    setExcelJson(null);
    setDocErrors({});
    setShow(false);
  };
  const handleShow = () => setShow(true);

  // Function to handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check for valid file type
      const validFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (!validFileTypes.includes(file.type)) {
        setDocErrors({
          document_file: "Please upload a valid Excel file (.xlsx or .xls).",
        });
        setFileName("");
        return;
      }

      setFileName(file.name);
      readExcel(file); // Convert the file to JSON
    } else {
      setFileName("");
    }
  };

  const readExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: null,
      });

      const headers = json[0];
      const rows = json.slice(1);

      const convertToYYYYMMDD = (input) => {
        try {
          let date;
          if (typeof input === "number") {
            const excelEpoch = new Date(1900, 0, 1);
            const daysOffset = input - 1;
            date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
          } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
            const [year, month, day] = input.split(".");
            date = new Date(`${year}-${month}-${day}`);
          } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
            const [day, month, year] = input.split(".");
            date = new Date(`${year}-${month}-${day}`);
          } else {
            date = new Date(input);
          }
          if (isNaN(date.getTime())) throw new Error("Invalid date");
          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        } catch {
          return null;
        }
      };

      // Filter out completely empty rows
      const filteredRows = rows.filter((row) =>
        row.some((cell) => cell !== null && cell !== undefined && cell !== ""),
      );

      const formattedJson = filteredRows.map((row) => {
        const obj = {};
        headers.forEach((header, index) => {
          let value = row[index] !== undefined ? row[index] : null;

          if (
            ["completion_date"].includes(header) &&
            value &&
            typeof value === "number"
          ) {
            value = convertToYYYYMMDD(value);
          }

          if (header === "state") {
            obj["length"] = value; // 👈 put state data into length
          } else {
            obj[header] = value;
          }
        });
        return obj;
      });

      setExcelJson(formattedJson);
    };
    reader.readAsArrayBuffer(file);
  };

  // Function to handle the upload button click
  const handleUpload = async () => {
    if (excelJson) {
      const loadingToastId = toast.loading("Uploading: Please wait...");
      try {
        const res = await axios.post(
          `${BASE_URL}/siteproject/certificatebulkcreate/`,
          excelJson,
        );
        if (res.status === 201) {
          await getData();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("Data uploaded successfully.");
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add data!");
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    } else {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
    }
  };

  return (
    <>
      <button
        title="Upload"
        className="model-button   font-weight500   model-button-print"
        onClick={handleShow}
        style={{ margin: "2px" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="22"
          id="upload"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          >
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
          </g>
        </svg>
      </button>

      <Modal show={show} dialogClassName="ourcompany-model">
        <Modal.Body>
          <div className="flex-row align-center">
            <h1 className="font-size-text task-Tab-heading align-center  font-weight500 ">
              <Modal.Title>
                Upload Company Credential Details in Bulk :
              </Modal.Title>{" "}
            </h1>

            <button
              onClick={handleDownload}
              className="model-button-download model-button font-weight500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="download"
                fill="#fff"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Format
            </button>
          </div>

          <div
            className="table-css-white-background"
            style={{ display: "none" }}
          >
            <table ref={bulktableRef} className="nested-table-lightblue">
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="align-left">project_code</th>
                  <th className="table-heading-text">project_name</th>
                  <th className="table-heading-text">sub_company</th>
                  <th className="table-heading-text">project_short_name</th>
                  <th className="table-heading-text">project_type</th>
                  <th className="table-heading-text">state</th>
                  <th className="table-heading-text">client</th>
                  <th className="table-heading-text">project_length</th>
                  <th className="table-heading-text">lane</th>
                  <th className="table-heading-text">special_structure</th>
                  <th className="table-heading-text">participate_as</th>
                  <th className="table-heading-text">
                    share_mention_on_clientcertificate
                  </th>
                  <th className="table-heading-text">
                    share_asper_certificate
                  </th>
                  <th className="table-heading-text">
                    CA_Certificate_available
                  </th>
                  <th className="table-heading-text">
                    share_as_per_ca_certificate
                  </th>
                  <th className="table-heading-text">project_cost_cr</th>
                  <th className="table-heading-text">
                    total_consultancy_fees_cr
                  </th>
                  <th className="table-heading-text">completion_date</th>
                  <th className="table-heading-text">remark</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="align-left">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="table-css-white-background scroll-container">
            <div
              className="table-container scrollbar"
              style={{ width: "100%" }}
            >
              <table
                className="nested-table-lightblue"
                style={{ margin: "0px" }}
              >
                <thead className="table-heading">
                  <tr className="custom-table-head-tr modal-padding-heading">
                    <th className="align-left">project_code</th>
                    <th className="table-heading-text">project_name</th>
                    <th className="table-heading-text">sub_company</th>
                    <th className="table-heading-text">project_short_name</th>
                    <th className="table-heading-text">project_type</th>
                    <th className="table-heading-text">state</th>
                    <th className="table-heading-text">client</th>
                    <th className="table-heading-text">project_length</th>
                    <th className="table-heading-text">lane</th>
                    <th className="table-heading-text">special_structure</th>
                    <th className="table-heading-text">participate_as</th>
                    <th className="table-heading-text">
                      share_mention_on_clientcertificate
                    </th>
                    <th className="table-heading-text">
                      share_asper_certificate
                    </th>
                    <th className="table-heading-text">
                      CA_Certificate_available
                    </th>
                    <th className="table-heading-text">
                      share_as_per_ca_certificate
                    </th>
                    <th className="table-heading-text">project_cost_cr</th>
                    <th className="table-heading-text">
                      total_consultancy_fees_cr
                    </th>
                    <th className="table-heading-text">completion_date</th>
                    <th className="table-heading-text">remark</th>
                  </tr>
                </thead>
                <tbody>
                  {excelJson?.map((project, index) => (
                    <tr key={index} className="modal-padding-heading">
                      <th className="table-heading-text">
                        {project.project_code}
                      </th>
                      <th className="table-heading-text">
                        {project.project_name}
                      </th>
                      <th className="table-heading-text">
                        {project.sub_company}
                      </th>
                      <th className="table-heading-text">
                        {project.project_short_name}
                      </th>
                      <th className="table-heading-text">
                        {project.project_type}
                      </th>
                      <th className="table-heading-text">{project.length}</th>
                      <th className="table-heading-text">{project.client}</th>
                      <th className="table-heading-text">
                        {project.project_length}
                      </th>
                      <th className="table-heading-text">{project.lane}</th>
                      <th className="table-heading-text">
                        {project.special_structure}
                      </th>
                      <th className="table-heading-text">
                        {project.participate_as}
                      </th>
                      <th className="table-heading-text">
                        {project.share_mention_on_clientcertificate
                          ? "true"
                          : "false"}
                      </th>
                      <th className="table-heading-text">
                        {project.share_asper_certificate}
                      </th>
                      <th className="table-heading-text">
                        {project.CA_Certificate_available ? "true" : "false"}
                      </th>
                      <th className="table-heading-text">
                        {project.share_as_per_ca_certificate}
                      </th>
                      <th className="table-heading-text">
                        {project.project_cost_cr}
                      </th>
                      <th className="table-heading-text">
                        {project.total_consultancy_fees_cr}
                      </th>
                      <th className="table-heading-text">
                        {project.completion_date
                          ? formatDate(project.completion_date)
                          : "-"}
                      </th>
                      <th className="table-heading-text">{project.remark}</th>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex-column field-cont-div">
            <label
              htmlFor="document_file"
              className="form-labels announce-date font-weight500 font-size-heading"
            >
              Upload File
            </label>
            <label
              htmlFor="document_file"
              className={`align-center form-inputss custom-file-upload ${
                docErrors.document_file
                  ? "error"
                  : docInputState.document_file
                    ? "success"
                    : ""
              }`}
            >
              <svg
                className="pdf-input"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                  stroke="#707070"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>
            <input
              id="document_file"
              name="document_file"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="file-inputs align-center"
              style={{ display: "none", position: "relative" }}
            />
            {fileName && <p className="file-name align-center">{fileName}</p>}
            <br />
            {docErrors.document_file && (
              <span className="file-name error-message font-size-text ">
                {docErrors.document_file}
              </span>
            )}
          </div>

          <div className="button-models">
            <button
              className="model-button-cancel model-button font-weight500"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="model-button-download model-button font-weight500"
              onClick={handleUpload}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="upload"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Upload
            </button>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Addformat = ({ getFormat, toggleCompany, siteSubCompanyList }) => {
  const [show, setShow] = useState(false);
  const [fileNames, setFileNames] = useState([]);

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const [formData, setFormData] = useState({
    project: null,
    project_code: "",
    project_short_name: "",
    project_type: "",
    project_name: "",
    client: "",
    project_length: "",
    lane: "",
    length: "",
    special_structure: "",
    participate_as: "",
    share_mention_on_clientcertificate: false,
    share_asper_certificate: "",
    CA_Certificate_available: false,
    share_as_per_ca_certificate: "",
    project_cost_cr: "",
    total_consultancy_fees_cr: "",
    completion_date: null,
    remark: "",
    LOA_copy_multiple: [{ document_name: "", document_file: "" }],
    certificate_copy_multiple: [{ document_name: "", document_file: "" }],
    sub_company: "null",
  });
  const [projectbyId, setProjectbyID] = useState("null");

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [projectList, setProjectList] = useState([]);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = ["sub_company"];

    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field] === "null") {
        newErrors[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };
  console.log("errors");
  console.log(errors);
  const getProject = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const pro = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbysubcompany/${formData.sub_company}/`,
      );
      const sortedList = sortProjects(pro.data, "site_prcode");
      setProjectList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    if (formData.sub_company) {
      getProject();
    }
  }, [formData.sub_company]);

  useEffect(() => {
    if (formData.project && projectbyId) {
      setFormData((prevData) => ({
        ...prevData,
        project_short_name: projectbyId.project_short_name,
        project_name: projectbyId.project_name,
        project_code: projectbyId.site_prcode,
        project_type: projectbyId.work_type,
        client: projectbyId.client_name,
        project_length: projectbyId.project_length,
        length: projectbyId.location,
      }));
    }
  }, [formData.project, projectbyId]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      project_short_name: "",
      project_name: "",
      project_code: "",
      project_type: "",
      client: "",
      project_length: "",
      length: "",
      project: null,
    }));
  }, [formData.sub_company]);

  useEffect(() => {
    if (formData.project === "null") {
      setFormData((prevData) => ({
        ...prevData,
        project_short_name: "",
        project_full_name: "",
        project_code: "",
        project_type: "",
        length: "",
        client: "",
        project_length: "",
      }));
    }
  }, [formData.project]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      sub_company: toggleCompany,
    }));
  }, [toggleCompany]);

  const getProjectbyID = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/projectbyid/${formData.project}/`,
      );
      setProjectbyID(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (formData.project !== "null") {
      getProjectbyID();
    }
  }, [formData.project]);

  const handleDocInputChange = (index, e) => {
    const { name, value, files } = e.target;

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      newDocuments[index] = {
        ...newDocuments[index],
        [name]: files ? files[0] : value, // Removed .trim()
      };

      if (files) {
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = files[0]?.name || "";
          return newFileNames;
        });
      }

      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (name === "document_name" && value.trim()) {
          delete updatedErrors[`document_name_${index}`];
        }
        if (name === "document_file" && files?.[0]) {
          delete updatedErrors[`document_file_${index}`];
        }
        return updatedErrors;
      });

      return { ...prevFormData, documents: newDocuments };
    });
  };

  const handleAddDocuments = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: [
        ...prevFormData.documents,
        { document_name: "", document_file: null },
      ],
    }));
  };

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents.filter((_, i) => i !== index),
    }));
    setFileNames((prevFileNames) =>
      prevFileNames.filter((_, i) => i !== index),
    );
  };

  const [loading, setLoading] = useState(false);

  const [uploadProgress, setUploadProgress] = useState(0); // For upload progress

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      // const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const res = await axiosInstance2.post(
          `${BASE_URL}/siteproject/certificate/`,
          formData,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              setUploadProgress(percentCompleted);
            },
          },
        );

        if (res.status === 201) {
          await getFormat();
          toast.success("Data uploaded successfully!");
          handleClose();
        }
      } catch (err) {
        toast.error("Error uploading documents");
        console.error("Error uploading documents", err);
      } finally {
        setLoading(false);
        // toast.dismiss(loadingToastId);
        setUploadProgress(0);
      }
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value, type, checked, options } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Update input state with feedback
    setInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    // Update form data with dynamic calculations
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };
      return updatedFormData;
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value.trim()) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const ProjectListOption = projectList
    ?.sort((a, b) => a.site_prcode.localeCompare(b.site_prcode))
    .map((i) => ({
      value: i.id,
      label: `${i.site_prcode} - ${i.project_short_name}`,
    }));

  const sortedStatesAndUTs = [...statesAndUTs].sort();

  const [location, setLocation] = useState([]);

  useEffect(() => {
    const uniqueLocations = [
      ...new Set(
        sortedStatesAndUTs
          .map((item) => item?.trim())
          .filter((type) => type && type !== ""),
      ),
    ]
      .sort((a, b) => a.localeCompare(b))
      .map((type) => ({ location: type }));

    setLocation(uniqueLocations);
  }, [statesAndUTs]);

  const StatesOptions = location
    ?.sort((a, b) => a.location.localeCompare(b.location))
    .map((i) => ({
      value: i.location,
      label: `${i.location}`,
    }));

  const handleLocationChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        length: "",
      });
    } else {
      setFormData({
        ...formData,
        length: selectedOption.value,
      });
    }
  };
  const handleProjectChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        project: "",
      });
    } else {
      setFormData({
        ...formData,
        project: selectedOption.value,
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  };

  console.log("formData");
  console.log(formData);
  return (
    <>
      <button
        title="Add Company Credential"
        className="upload-svg"
        onClick={handleShow}
      >
        {/* Replace with your icon component */}
        <AddwithWhiteCircle /> Company Credential
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Add Company Credential Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-flex-wrap">
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div
                title="Site Sub Company"
                className="flex-column form-group-selectt"
              >
                <label
                  htmlFor="sub_company"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Site Sub Company <span className="required">*</span>
                </label>
                <br />
                <select
                  id="sub_company"
                  name="sub_company"
                  value={formData.sub_company}
                  onChange={handleInputChange}
                  className={`form-input width-15vw form-group-selection ${
                    errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                  }`}
                >
                  <option value="null">Select a Site SubCompany</option>
                  {siteSubCompanyList
                    ?.sort((a, b) =>
                      a.title.localeCompare(b.title, "en", {
                        ignorePunctuation: true,
                      }),
                    )
                    .map((i, index) => (
                      <>
                        <option value={i.id}>{i.title}</option>
                      </>
                    ))}
                </select>

                <div>
                  {errors.sub_company && (
                    <span className="error-message font-size-text ">
                      {errors.sub_company}
                    </span>
                  )}
                </div>
              </div>
              <div title="Project" className="flex-column form-group-selectt">
                <label
                  htmlFor="project"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Project
                </label>
                <br />
                <Select
                  options={ProjectListOption}
                  onChange={handleProjectChange}
                  value={
                    formData.project === "null" ||
                    formData.project === undefined
                      ? "null"
                      : ProjectListOption.find(
                          (option) => option.value === formData.project,
                        )
                  }
                  placeholder="Select a Project"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No other options"}
                  styles={CSSForSelect15vWWidth}
                  className=""
                />

                <div>
                  {errors.project && (
                    <span className="error-message font-size-text ">
                      {errors.project}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div title="project_code" className="flex-column">
                <label
                  htmlFor="project_code"
                  className="form-labels  font-weight500    "
                >
                  Project Code
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="project_code"
                  name="project_code"
                  placeholder="Project Code"
                  onChange={handleInputChange}
                  value={formData.project_code}
                  className={`form-input width-15vw  ${
                    errors.project_code
                      ? "error"
                      : inputState.project_code
                        ? "success"
                        : ""
                  }`}
                />
                {errors.project_code && (
                  <span className="error-message font-size-text ">
                    {errors.project_code}
                  </span>
                )}
              </div>
              <div title="project_short_name" className="flex-column">
                <label
                  htmlFor="project_short_name"
                  className="form-labels  font-weight500    "
                >
                  Project Short Name
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="project_short_name"
                  name="project_short_name"
                  placeholder="Project Short Name"
                  onChange={handleInputChange}
                  value={formData.project_short_name}
                  className={`form-input width-15vw  ${
                    errors.project_short_name
                      ? "error"
                      : inputState.project_short_name
                        ? "success"
                        : ""
                  }`}
                />
                {errors.project_short_name && (
                  <span className="error-message font-size-text ">
                    {errors.project_short_name}
                  </span>
                )}
              </div>
            </div>

            <div title="project_name" className="flex-column">
              <label
                htmlFor="project_name"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Project Full Name
              </label>
              <textarea
                type="text"
                // maxLength={100}
                id="project_name"
                name="project_name"
                placeholder="Project Full Name"
                onChange={handleInputChange}
                value={formData.project_name}
                style={{ width: "77vw", height: "90px" }}
                className={`form-input form-input-textarea ${
                  errors.project_name
                    ? "error"
                    : inputState.project_name
                      ? "success"
                      : ""
                }`}
              />
              {errors.project_name && (
                <span className="error-message font-size-text ">
                  {errors.project_name}
                </span>
              )}
            </div>
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div title="project_type" className="flex-column">
                <label
                  htmlFor="project_type"
                  className="form-labels  font-weight500    "
                >
                  Project Type
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="project_type"
                  name="project_type"
                  placeholder="Project type"
                  onChange={handleInputChange}
                  value={formData.project_type}
                  className={`form-input width-15vw ${
                    errors.project_type
                      ? "error"
                      : inputState.project_type
                        ? "success"
                        : ""
                  }`}
                />
                {errors.project_type && (
                  <span className="error-message font-size-text ">
                    {errors.project_type}
                  </span>
                )}
              </div>
              <div title="State" className="flex-column form-group-selectt">
                <label
                  htmlFor="length"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  State
                </label>
                <br />
                <Select
                  options={StatesOptions}
                  onChange={handleLocationChange}
                  value={StatesOptions.find(
                    (option) => option.value === formData.length,
                  )}
                  placeholder="Select a Location"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No other options"}
                  styles={CSSForSelect15vWWidth}
                  className=""
                />

                <div>
                  {errors.length && (
                    <span className="error-message font-size-text ">
                      {errors.length}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div title="client" className="flex-column">
              <label
                htmlFor="client"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Client
              </label>
              <input
                type="text"
                maxLength={100}
                id="client"
                name="client"
                placeholder="Client"
                onChange={handleInputChange}
                value={formData.client}
                className={`form-input ${
                  errors.client ? "error" : inputState.client ? "success" : ""
                }`}
              />
              {errors.client && (
                <span className="error-message font-size-text ">
                  {errors.client}
                </span>
              )}
            </div>
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div title="project_length" className="flex-column">
                <label
                  htmlFor="project_length"
                  className="form-labels  font-weight500    "
                >
                  Project Length
                </label>
                <input
                  type="number"
                  min={0}
                  id="project_length"
                  name="project_length"
                  placeholder="Project Length"
                  onChange={handleInputChange}
                  value={formData.project_length}
                  className={`form-input width-15vw ${
                    errors.project_length
                      ? "error"
                      : inputState.project_length
                        ? "success"
                        : ""
                  }`}
                />
                {errors.project_length && (
                  <span className="error-message font-size-text ">
                    {errors.project_length}
                  </span>
                )}
              </div>
              <div title="lane" className="flex-column">
                <label
                  htmlFor="lane"
                  className="form-labels  font-weight500    "
                >
                  Lane
                </label>
                <input
                  type="number"
                  min={0}
                  id="lane"
                  name="lane"
                  placeholder="Lane"
                  onChange={handleInputChange}
                  value={formData.lane}
                  className={`form-input width-15vw ${
                    errors.lane ? "error" : inputState.lane ? "success" : ""
                  }`}
                />
                {errors.lane && (
                  <span className="error-message font-size-text ">
                    {errors.lane}
                  </span>
                )}
              </div>
            </div>

            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <>
                <div title="project_cost_cr" className="flex-column">
                  <label
                    htmlFor="project_cost_cr"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Project Cost (in Crores)
                  </label>
                  <input
                    type="number"
                    maxLength={100}
                    id="project_cost_cr"
                    name="project_cost_cr"
                    placeholder="Project Cost"
                    onChange={handleInputChange}
                    value={formData.project_cost_cr}
                    className={`form-input width-15vw ${
                      errors.project_cost_cr
                        ? "error"
                        : inputState.project_cost_cr
                          ? "success"
                          : ""
                    }`}
                  />
                  {errors.project_cost_cr && (
                    <span className="error-message font-size-text ">
                      {errors.project_cost_cr}
                    </span>
                  )}
                </div>
              </>
              <div title="total_consultancy_fees_cr" className="flex-column">
                <label
                  htmlFor="total_consultancy_fees_cr"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Total Consultancy Fees (in Crores)
                </label>
                <input
                  type="number"
                  min={0}
                  id="total_consultancy_fees_cr"
                  name="total_consultancy_fees_cr"
                  placeholder="e.g. 2.5 (in crores)"
                  onChange={handleInputChange}
                  value={formData.total_consultancy_fees_cr}
                  className={`form-input width-15vw ${
                    errors.total_consultancy_fees_cr
                      ? "error"
                      : inputState.total_consultancy_fees_cr
                        ? "success"
                        : ""
                  }`}
                />
                {errors.total_consultancy_fees_cr && (
                  <span className="error-message font-size-text ">
                    {errors.total_consultancy_fees_cr}
                  </span>
                )}
              </div>
            </div>

            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div title="Completion Date" className="flex-column">
                <label
                  htmlFor="completion_date"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Completion Date
                </label>
                <input
                  type="date"
                  id="completion_date"
                  name="completion_date"
                  onChange={handleInputChange}
                  value={formData.completion_date}
                  className={`form-input width-15vw ${
                    errors.completion_date
                      ? "error"
                      : inputState.completion_date
                        ? "success"
                        : ""
                  }`}
                />
                {errors.completion_date && (
                  <span className="error-message font-size-text ">
                    {errors.completion_date}
                  </span>
                )}
              </div>
              <div title="participate_as" className="flex-column">
                <label
                  htmlFor="participate_as"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Participate AS
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="participate_as"
                  name="participate_as"
                  placeholder="Participate AS"
                  onChange={handleInputChange}
                  value={formData.participate_as}
                  className={`form-input width-15vw ${
                    errors.participate_as
                      ? "error"
                      : inputState.participate_as
                        ? "success"
                        : ""
                  }`}
                />
                {errors.participate_as && (
                  <span className="error-message font-size-text ">
                    {errors.participate_as}
                  </span>
                )}
              </div>
            </div>
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <>
                <div
                  title="share_mention_on_clientcertificate"
                  className="flex-column"
                >
                  <div className="flex-row">
                    <label
                      htmlFor="share_mention_on_clientcertificate"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Share as per Cilent Certificate{" "}
                    </label>
                    <hr className="field-cont-hr" />
                    <div className="checkbox-toggle">
                      <input
                        id="share_mention_on_clientcertificate"
                        name="share_mention_on_clientcertificate"
                        type="checkbox"
                        value={formData.share_mention_on_clientcertificate}
                        className={`form-checkbox ${errors.share_mention_on_clientcertificate ? "error" : inputState.share_mention_on_clientcertificate ? "success" : ""}`}
                        onChange={handleInputChange}
                        checked={formData.share_mention_on_clientcertificate}
                      />
                      <label htmlFor="share_mention_on_clientcertificate"></label>
                    </div>
                  </div>
                  <>
                    {formData.share_mention_on_clientcertificate === true && (
                      <>
                        <input
                          type="number"
                          maxLength={100}
                          id="share_asper_certificate"
                          name="share_asper_certificate"
                          placeholder="Share as per Cilent Certificate"
                          onChange={handleInputChange}
                          value={formData.share_asper_certificate}
                          className={`form-input width-15vw ${
                            errors.share_asper_certificate
                              ? "error"
                              : inputState.share_asper_certificate
                                ? "success"
                                : ""
                          }`}
                        />

                        {errors.share_asper_certificate && (
                          <span className="error-message font-size-text ">
                            {errors.share_asper_certificate}
                          </span>
                        )}
                      </>
                    )}
                  </>
                </div>
              </>

              <>
                <div title="CA_Certificate_available" className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="CA_Certificate_available"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Share as per CA Certificate{" "}
                    </label>
                    <hr className="field-cont-hr" />
                    <div className="checkbox-toggle">
                      <input
                        id="CA_Certificate_available"
                        name="CA_Certificate_available"
                        type="checkbox"
                        value={formData.CA_Certificate_available}
                        className={`form-checkbox ${errors.CA_Certificate_available ? "error" : inputState.CA_Certificate_available ? "success" : ""}`}
                        onChange={handleInputChange}
                        checked={formData.CA_Certificate_available}
                      />
                      <label htmlFor="CA_Certificate_available"></label>
                    </div>
                  </div>
                  <>
                    {formData.CA_Certificate_available === true && (
                      <>
                        <input
                          type="number"
                          maxLength={100}
                          id="share_as_per_ca_certificate"
                          name="share_as_per_ca_certificate"
                          placeholder="Share as per CA Certificate"
                          onChange={handleInputChange}
                          value={formData.share_as_per_ca_certificate}
                          className={`form-input width-15vw ${
                            errors.share_as_per_ca_certificate
                              ? "error"
                              : inputState.share_as_per_ca_certificate
                                ? "success"
                                : ""
                          }`}
                        />

                        {errors.share_as_per_ca_certificate && (
                          <span className="error-message font-size-text ">
                            {errors.share_as_per_ca_certificate}
                          </span>
                        )}
                      </>
                    )}
                  </>
                </div>
              </>
            </div>

            <div title="special_structure" className="flex-column">
              <label
                htmlFor="special_structure"
                className="form-labels font-weight500 font-size-subheading"
              >
                Special Structure
              </label>
              <input
                type="text"
                maxLength={100}
                id="special_structure"
                name="special_structure"
                placeholder="Special Structure"
                onChange={handleInputChange}
                value={formData.special_structure}
                className={`form-input ${
                  errors.special_structure
                    ? "error"
                    : inputState.special_structure
                      ? "success"
                      : ""
                }`}
              />
              {errors.special_structure && (
                <span className="error-message font-size-text ">
                  {errors.special_structure}
                </span>
              )}
            </div>

            <div title="remark" className="flex-column">
              <label
                htmlFor="remark"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Remarks
              </label>
              <input
                type="text"
                id="remark"
                name="remark"
                placeholder="Remarks"
                onChange={handleInputChange}
                value={formData.remark}
                className={`form-input ${
                  errors.remark ? "error" : inputState.remark ? "success" : ""
                }`}
              />
              {errors.remark && (
                <span className="error-message font-size-text ">
                  {errors.remark}
                </span>
              )}
            </div>
          </div>

          {/* Upload Progress Bar */}
          {uploadProgress > 0 && (
            <div className="progress-bar">
              <h6 className="uploading-percentage">
                Uploading {uploadProgress}%
              </h6>
              <div
                className="progress-bar-fill"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
          )}

          <div className="button-models">
            <button
              onClick={handleFormSubmit}
              className="model-button font-weight500 model-button-submit"
              disabled={loading}
              type="button"
            >
              Submit
            </button>
          </div>
          <p className="error-message font-size-text">
            {isSubmitted &&
              Object.keys(errors).length > 0 &&
              (Object.keys(errors).length > 5 ? (
                <h5 className="text-center">
                  Please fill all mandatory fields!
                </h5>
              ) : (
                <h6 className="text-center">
                  {Object.keys(errors)
                    .map(
                      (field) => field.charAt(0).toUpperCase() + field.slice(1),
                    )
                    .join(", ") + " are required!"}
                </h6>
              ))}
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};
const UpdateFormat = ({
  updateTrackRecord,
  toggleCompany,
  siteSubCompanyList,
  i,
}) => {
  const [show, setShow] = useState(false);
  const [fileNames, setFileNames] = useState([]);

  const handleShow = () => {
    setShow(true);

    setFormData((prev) => ({
      ...prev,
      ...i,
      sub_company: i.sub_company || toggleCompany || "null",
    }));
  };

  const handleClose = () => {
    setShow(false);
  };

  const [formData, setFormData] = useState({
    project: null,
    project_code: "",
    project_short_name: "",
    project_type: "",
    project_name: "",
    client: "",
    project_length: "",
    lane: "",
    length: "",
    special_structure: "",
    participate_as: "",
    share_mention_on_clientcertificate: false,
    share_asper_certificate: "",
    CA_Certificate_available: false,
    share_as_per_ca_certificate: "",
    project_cost_cr: "",
    total_consultancy_fees_cr: "",
    completion_date: null,
    remark: "",
    sub_company: toggleCompany ? toggleCompany : "null",
  });
  const [projectbyId, setProjectbyID] = useState("null");

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [projectList, setProjectList] = useState([]);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const requiredFields = [];

    const newErrors = requiredFields.reduce((acc, field) => {
      if (
        !formData[field] ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        acc[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
      return acc;
    }, {});

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const getProject = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const pro = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbysubcompany/${formData.sub_company}/`,
      );
      const sortedList = sortProjects(pro.data, "site_prcode");
      setProjectList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    if (formData.sub_company && show === true) {
      getProject();
    }
  }, [formData.sub_company, show]);

  useEffect(() => {
    if (formData.project && projectbyId) {
      setFormData((prevData) => ({
        ...prevData,
        project_short_name: projectbyId.project_short_name,
        project_name: projectbyId.project_name,
        project_code: projectbyId.site_prcode,
        project_type: projectbyId.work_type,
        client: projectbyId.client_name,
        project_length: projectbyId.project_length,
        length: projectbyId.location,
      }));
    }
  }, [formData.project, projectbyId]);

  useEffect(() => {
    if (!i) {
      setFormData((prev) => ({
        ...prev,
        project_short_name: "",
        project_name: "",
        project_code: "",
        project_type: "",
        client: "",
        project_length: "",
        project: null,
        length: "",
      }));
    }
  }, [formData.sub_company]);

  useEffect(() => {
    if (formData.project === "null" && formData.project === null) {
      setFormData((prevData) => ({
        ...prevData,
        project_short_name: "",
        project_name: "",
        project_code: "",
        project_type: "",
        client: "",
        project_length: "",
        length: "",
      }));
    }
  }, [formData.project]);

  console.log("formData");
  console.log(formData);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      sub_company: toggleCompany,
    }));
  }, [toggleCompany]);

  const getProjectbyID = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/projectbyid/${formData.project}/`,
      );
      setProjectbyID(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (formData.project !== "null" && show === true) {
      getProjectbyID();
    }
  }, [formData.project, show]);

  const handleDocInputChange = (index, e) => {
    const { name, value, files } = e.target;

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      newDocuments[index] = {
        ...newDocuments[index],
        [name]: files ? files[0] : value, // Removed .trim()
      };

      if (files) {
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = files[0]?.name || "";
          return newFileNames;
        });
      }

      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (name === "document_name" && value.trim()) {
          delete updatedErrors[`document_name_${index}`];
        }
        if (name === "document_file" && files?.[0]) {
          delete updatedErrors[`document_file_${index}`];
        }
        return updatedErrors;
      });

      return { ...prevFormData, documents: newDocuments };
    });
  };

  const handleAddDocuments = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: [
        ...prevFormData.documents,
        { document_name: "", document_file: null },
      ],
    }));
  };

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents.filter((_, i) => i !== index),
    }));
    setFileNames((prevFileNames) =>
      prevFileNames.filter((_, i) => i !== index),
    );
  };

  const [loading, setLoading] = useState(false);

  const [uploadProgress, setUploadProgress] = useState(0); // For upload progress

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      // const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        // const formDataToSend = new FormData();

        // // // Append general form fields (excluding documents)
        // Object.keys(formData).forEach((key) => {
        //   if (key !== "documents" && formData[key]) {
        //     if (key === "associated_letters") {
        //       formDataToSend.append(key, JSON.stringify(formData[key])); // stringify the array
        //     } else {
        //       formDataToSend.append(key, formData[key]);
        //     }
        //   }
        // });

        // // Upload files in chunks and collect file IDs
        // let fileIndex = 0;
        // for (let doc of formData.documents) {
        //   if (doc.document_file) {
        //     const fileId = await uploadFileInChunks(
        //       doc.document_file,
        //       doc.document_name,
        //       setUploadProgress
        //     );
        //     if (!fileId) {
        //       console.error(`❌ Failed to upload file: ${doc.document_name}`);
        //       continue; // Skip this file instead of returning
        //     }
        //     console.log(doc, "documents");
        //     formDataToSend.append("file_ids", fileId);
        //     formDataToSend.append(
        //       `documents[${fileIndex}][document_name]`,
        //       doc.document_name
        //     );
        //     formDataToSend.append(
        //       `documents[${fileIndex}][original_filename]`,
        //       doc.document_file.name
        //     );
        //     formDataToSend.append(
        //       `documents[${fileIndex}][file]`,
        //       doc.document_file
        //     );

        //     fileIndex++; // Ensure indices remain correct
        //   }
        // }

        // if (!formDataToSend.has("file_ids")) {
        //   console.error("❌ No valid files were uploaded.");
        //   setLoading(false);
        //   return;
        // }

        // Send request with updated FormData
        const res = await axios.put(
          `${BASE_URL}/siteproject/certificateupate/${i.id}/`,
          formData,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              setUploadProgress(percentCompleted);
            },
          },
        );

        if (res.status === 200) {
          updateTrackRecord(res.data);
          toast.success("Data updated successfully!");
          handleClose();
        }
      } catch (err) {
        toast.error("Error uploading documents");
        console.error("Error uploading documents", err);
      } finally {
        setLoading(false);
        // toast.dismiss(loadingToastId);
        setUploadProgress(0);
      }
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value, type, checked, options } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Update input state with feedback
    setInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    // Update form data with dynamic calculations
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };
      return updatedFormData;
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value.trim()) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const ProjectListOption = projectList
    ?.sort((a, b) => a.site_prcode.localeCompare(b.site_prcode))
    .map((i) => ({
      value: i.id,
      label: `${i.site_prcode} - ${i.project_short_name}`,
    }));

  const handleProjectChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        project: "",
      });
    } else {
      setFormData({
        ...formData,
        project: selectedOption.value,
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  };

  const sortedStatesAndUTs = [...statesAndUTs].sort();

  const [location, setLocation] = useState([]);

  useEffect(() => {
    const uniqueLocations = [
      ...new Set(
        sortedStatesAndUTs
          .map((item) => item?.trim())
          .filter((type) => type && type !== ""),
      ),
    ]
      .sort((a, b) => a.localeCompare(b))
      .map((type) => ({ location: type }));

    setLocation(uniqueLocations);
  }, [statesAndUTs]);

  const StatesOptions = location
    ?.sort((a, b) => a.location.localeCompare(b.location))
    .map((i) => ({
      value: i.location,
      label: `${i.location}`,
    }));

  const handleLocationChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        length: "",
      });
    } else {
      setFormData({
        ...formData,
        length: selectedOption.value,
      });
    }
  };
  return (
    <>
      <button
        title="Update Details"
        className="model-edit-button"
        onClick={handleShow}
      >
        <UpdatePencil />{" "}
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Update Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-flex-wrap">
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div
                title="Site Sub Company"
                className="flex-column form-group-selectt"
              >
                <label
                  htmlFor="sub_company"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Site Sub Company <span className="required">*</span>
                </label>
                <br />
                <select
                  id="sub_company"
                  name="sub_company"
                  value={formData.sub_company}
                  onChange={handleInputChange}
                  className={`form-input width-15vw form-group-selection ${
                    errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                  }`}
                >
                  <option value="null">Select a Site SubCompany</option>
                  {siteSubCompanyList
                    ?.sort((a, b) =>
                      a.title.localeCompare(b.title, "en", {
                        ignorePunctuation: true,
                      }),
                    )
                    .map((i, index) => (
                      <>
                        <option value={i.id}>{i.title}</option>
                      </>
                    ))}
                </select>

                <div>
                  {errors.sub_company && (
                    <span className="error-message font-size-text ">
                      {errors.sub_company}
                    </span>
                  )}
                </div>
              </div>
              <div title="Project" className="flex-column form-group-selectt">
                <label
                  htmlFor="project"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Project
                </label>
                <br />
                <Select
                  options={ProjectListOption}
                  onChange={handleProjectChange}
                  value={
                    formData.project === "null" ||
                    formData.project === undefined
                      ? "null"
                      : ProjectListOption.find(
                          (option) => option.value === formData.project,
                        )
                  }
                  placeholder="Select a Project"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No other options"}
                  styles={CSSForSelect15vWWidth}
                  className=""
                />

                <div>
                  {errors.project && (
                    <span className="error-message font-size-text ">
                      {errors.project}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div title="project_code" className="flex-column">
                <label
                  htmlFor="project_code"
                  className="form-labels  font-weight500    "
                >
                  Project Code
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="project_code"
                  name="project_code"
                  placeholder="Project Code"
                  onChange={handleInputChange}
                  value={formData.project_code}
                  className={`form-input width-15vw  ${
                    errors.project_code
                      ? "error"
                      : inputState.project_code
                        ? "success"
                        : ""
                  }`}
                />
                {errors.project_code && (
                  <span className="error-message font-size-text ">
                    {errors.project_code}
                  </span>
                )}
              </div>
              <div title="project_short_name" className="flex-column">
                <label
                  htmlFor="project_short_name"
                  className="form-labels  font-weight500    "
                >
                  Project Short Name
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="project_short_name"
                  name="project_short_name"
                  placeholder="Project Short Name"
                  onChange={handleInputChange}
                  value={formData.project_short_name}
                  className={`form-input width-15vw  ${
                    errors.project_short_name
                      ? "error"
                      : inputState.project_short_name
                        ? "success"
                        : ""
                  }`}
                />
                {errors.project_short_name && (
                  <span className="error-message font-size-text ">
                    {errors.project_short_name}
                  </span>
                )}
              </div>
            </div>

            <div title="project_name" className="flex-column">
              <label
                htmlFor="project_name"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Project Full Name
              </label>
              <textarea
                type="text"
                // maxLength={100}
                id="project_name"
                name="project_name"
                placeholder="Project Full Name"
                onChange={handleInputChange}
                value={formData.project_name}
                style={{ width: "77vw", height: "90px" }}
                className={`form-input form-input-textarea ${
                  errors.project_name
                    ? "error"
                    : inputState.project_name
                      ? "success"
                      : ""
                }`}
              />
              {errors.project_name && (
                <span className="error-message font-size-text ">
                  {errors.project_name}
                </span>
              )}
            </div>
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div title="project_type" className="flex-column">
                <label
                  htmlFor="project_type"
                  className="form-labels  font-weight500    "
                >
                  Project Type
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="project_type"
                  name="project_type"
                  placeholder="Project type"
                  onChange={handleInputChange}
                  value={formData.project_type}
                  className={`form-input width-15vw ${
                    errors.project_type
                      ? "error"
                      : inputState.project_type
                        ? "success"
                        : ""
                  }`}
                />
                {errors.project_type && (
                  <span className="error-message font-size-text ">
                    {errors.project_type}
                  </span>
                )}
              </div>
              <div title="State" className="flex-column form-group-selectt">
                <label
                  htmlFor="length"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  State
                </label>
                <br />
                <Select
                  options={StatesOptions}
                  onChange={handleLocationChange}
                  value={StatesOptions.find(
                    (option) => option.value === formData.length,
                  )}
                  placeholder="Select a Location"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "No other options"}
                  styles={CSSForSelect15vWWidth}
                  className=""
                />

                <div>
                  {errors.length && (
                    <span className="error-message font-size-text ">
                      {errors.length}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div title="client" className="flex-column">
              <label
                htmlFor="client"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Client
              </label>
              <input
                type="text"
                maxLength={100}
                id="client"
                name="client"
                placeholder="Client"
                onChange={handleInputChange}
                value={formData.client}
                className={`form-input ${
                  errors.client ? "error" : inputState.client ? "success" : ""
                }`}
              />
              {errors.client && (
                <span className="error-message font-size-text ">
                  {errors.client}
                </span>
              )}
            </div>
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div title="project_length" className="flex-column">
                <label
                  htmlFor="project_length"
                  className="form-labels  font-weight500    "
                >
                  Project Length
                </label>
                <input
                  type="number"
                  min={0}
                  id="project_length"
                  name="project_length"
                  placeholder="Project Length"
                  onChange={handleInputChange}
                  value={formData.project_length}
                  className={`form-input width-15vw ${
                    errors.project_length
                      ? "error"
                      : inputState.project_length
                        ? "success"
                        : ""
                  }`}
                />
                {errors.project_length && (
                  <span className="error-message font-size-text ">
                    {errors.project_length}
                  </span>
                )}
              </div>
              <div title="lane" className="flex-column">
                <label
                  htmlFor="lane"
                  className="form-labels  font-weight500    "
                >
                  Lane
                </label>
                <input
                  type="number"
                  min={0}
                  id="lane"
                  name="lane"
                  placeholder="Lane"
                  onChange={handleInputChange}
                  value={formData.lane}
                  className={`form-input width-15vw ${
                    errors.lane ? "error" : inputState.lane ? "success" : ""
                  }`}
                />
                {errors.lane && (
                  <span className="error-message font-size-text ">
                    {errors.lane}
                  </span>
                )}
              </div>
            </div>

            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <>
                <div title="project_cost_cr" className="flex-column">
                  <label
                    htmlFor="project_cost_cr"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Project Cost (in Crores)
                  </label>
                  <input
                    type="number"
                    maxLength={100}
                    id="project_cost_cr"
                    name="project_cost_cr"
                    placeholder="Project Cost"
                    onChange={handleInputChange}
                    value={formData.project_cost_cr}
                    className={`form-input width-15vw ${
                      errors.project_cost_cr
                        ? "error"
                        : inputState.project_cost_cr
                          ? "success"
                          : ""
                    }`}
                  />
                  {errors.project_cost_cr && (
                    <span className="error-message font-size-text ">
                      {errors.project_cost_cr}
                    </span>
                  )}
                </div>
              </>
              <div title="total_consultancy_fees_cr" className="flex-column">
                <label
                  htmlFor="total_consultancy_fees_cr"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Total Consultancy Fees (in Crores)
                </label>
                <input
                  type="number"
                  min={0}
                  id="total_consultancy_fees_cr"
                  name="total_consultancy_fees_cr"
                  placeholder="e.g. 2.5 (in crores)"
                  onChange={handleInputChange}
                  value={formData.total_consultancy_fees_cr}
                  className={`form-input width-15vw ${
                    errors.total_consultancy_fees_cr
                      ? "error"
                      : inputState.total_consultancy_fees_cr
                        ? "success"
                        : ""
                  }`}
                />
                {errors.total_consultancy_fees_cr && (
                  <span className="error-message font-size-text ">
                    {errors.total_consultancy_fees_cr}
                  </span>
                )}
              </div>
            </div>

            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <div title="Completion Date" className="flex-column">
                <label
                  htmlFor="completion_date"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Completion Date
                </label>
                <input
                  type="date"
                  id="completion_date"
                  name="completion_date"
                  onChange={handleInputChange}
                  value={formData.completion_date}
                  className={`form-input width-15vw ${
                    errors.completion_date
                      ? "error"
                      : inputState.completion_date
                        ? "success"
                        : ""
                  }`}
                />
                {errors.completion_date && (
                  <span className="error-message font-size-text ">
                    {errors.completion_date}
                  </span>
                )}
              </div>
              <div title="participate_as" className="flex-column">
                <label
                  htmlFor="participate_as"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Participate AS
                </label>
                <input
                  type="text"
                  maxLength={100}
                  id="participate_as"
                  name="participate_as"
                  placeholder="Participate AS"
                  onChange={handleInputChange}
                  value={formData.participate_as}
                  className={`form-input width-15vw ${
                    errors.participate_as
                      ? "error"
                      : inputState.participate_as
                        ? "success"
                        : ""
                  }`}
                />
                {errors.participate_as && (
                  <span className="error-message font-size-text ">
                    {errors.participate_as}
                  </span>
                )}
              </div>
            </div>
            <div className="flex-row justify-between" style={{ width: "34vw" }}>
              <>
                <div
                  title="share_mention_on_clientcertificate"
                  className="flex-column"
                >
                  <div className="flex-row">
                    <label
                      htmlFor="share_mention_on_clientcertificate"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Share as per Cilent Certificate{" "}
                    </label>
                    <hr className="field-cont-hr" />
                    <div className="checkbox-toggle">
                      <input
                        id="share_mention_on_clientcertificate"
                        name="share_mention_on_clientcertificate"
                        type="checkbox"
                        value={formData.share_mention_on_clientcertificate}
                        className={`form-checkbox ${errors.share_mention_on_clientcertificate ? "error" : inputState.share_mention_on_clientcertificate ? "success" : ""}`}
                        onChange={handleInputChange}
                        checked={formData.share_mention_on_clientcertificate}
                      />
                      <label htmlFor="share_mention_on_clientcertificate"></label>
                    </div>
                  </div>
                  <>
                    {formData.share_mention_on_clientcertificate === true && (
                      <>
                        <input
                          type="number"
                          maxLength={100}
                          id="share_asper_certificate"
                          name="share_asper_certificate"
                          placeholder="Share as per Cilent Certificate"
                          onChange={handleInputChange}
                          value={formData.share_asper_certificate}
                          className={`form-input width-15vw ${
                            errors.share_asper_certificate
                              ? "error"
                              : inputState.share_asper_certificate
                                ? "success"
                                : ""
                          }`}
                        />

                        {errors.share_asper_certificate && (
                          <span className="error-message font-size-text ">
                            {errors.share_asper_certificate}
                          </span>
                        )}
                      </>
                    )}
                  </>
                </div>
              </>

              <>
                <div title="CA_Certificate_available" className="flex-column">
                  <div className="flex-row">
                    <label
                      htmlFor="CA_Certificate_available"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Share as per CA Certificate{" "}
                    </label>
                    <hr className="field-cont-hr" />
                    <div className="checkbox-toggle">
                      <input
                        id="CA_Certificate_available"
                        name="CA_Certificate_available"
                        type="checkbox"
                        value={formData.CA_Certificate_available}
                        className={`form-checkbox ${errors.CA_Certificate_available ? "error" : inputState.CA_Certificate_available ? "success" : ""}`}
                        onChange={handleInputChange}
                        checked={formData.CA_Certificate_available}
                      />
                      <label htmlFor="CA_Certificate_available"></label>
                    </div>
                  </div>
                  <>
                    {formData.CA_Certificate_available === true && (
                      <>
                        <input
                          type="number"
                          maxLength={100}
                          id="share_as_per_ca_certificate"
                          name="share_as_per_ca_certificate"
                          placeholder="Share as per CA Certificate"
                          onChange={handleInputChange}
                          value={formData.share_as_per_ca_certificate}
                          className={`form-input width-15vw ${
                            errors.share_as_per_ca_certificate
                              ? "error"
                              : inputState.share_as_per_ca_certificate
                                ? "success"
                                : ""
                          }`}
                        />

                        {errors.share_as_per_ca_certificate && (
                          <span className="error-message font-size-text ">
                            {errors.share_as_per_ca_certificate}
                          </span>
                        )}
                      </>
                    )}
                  </>
                </div>
              </>
            </div>

            <div title="special_structure" className="flex-column">
              <label
                htmlFor="special_structure"
                className="form-labels font-weight500 font-size-subheading"
              >
                Special Structure
              </label>
              <input
                type="text"
                maxLength={100}
                id="special_structure"
                name="special_structure"
                placeholder="Special Structure"
                onChange={handleInputChange}
                value={formData.special_structure}
                className={`form-input ${
                  errors.special_structure
                    ? "error"
                    : inputState.special_structure
                      ? "success"
                      : ""
                }`}
              />
              {errors.special_structure && (
                <span className="error-message font-size-text ">
                  {errors.special_structure}
                </span>
              )}
            </div>

            <div title="remark" className="flex-column">
              <label
                htmlFor="remark"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Remarks
              </label>
              <input
                type="text"
                id="remark"
                name="remark"
                placeholder="Remarks"
                onChange={handleInputChange}
                value={formData.remark}
                className={`form-input ${
                  errors.remark ? "error" : inputState.remark ? "success" : ""
                }`}
              />
              {errors.remark && (
                <span className="error-message font-size-text ">
                  {errors.remark}
                </span>
              )}
            </div>
          </div>

          {/* Upload Progress Bar */}
          {uploadProgress > 0 && (
            <div className="progress-bar">
              <h6 className="uploading-percentage">
                Uploading {uploadProgress}%
              </h6>
              <div
                className="progress-bar-fill"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
          )}

          <div className="button-models">
            <button
              onClick={handleFormSubmit}
              className="model-button font-weight500 model-button-submit"
              disabled={loading}
              type="button"
            >
              Submit
            </button>
          </div>
          <p className="error-message font-size-text">
            {isSubmitted &&
              Object.keys(errors).length > 0 &&
              (Object.keys(errors).length > 5 ? (
                <h5 className="text-center">
                  Please fill all mandatory fields!
                </h5>
              ) : (
                <h6 className="text-center">
                  {Object.keys(errors)
                    .map(
                      (field) => field.charAt(0).toUpperCase() + field.slice(1),
                    )
                    .join(", ") + " are required!"}
                </h6>
              ))}
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteFormat = ({ i, getcertification }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/certificateupate/${i.id}/`,
      );

      if (res.status === 200) {
        await getcertification();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Button"
        className="model-delete-button"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete Data?
            <div className="button-models">
              <button
                className="model-button   font-weight500   model-button-cancel "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const CertificateFormat = ({
  projectId,
  letterBy,
  contractor,
  contractorlist,
}) => {
  const tableRef = useRef(null);
  const [toggleCompany, setToggleCompany] = useState("null");
  const [toggleProjectType, setToggleProjectType] = useState("null");
  const [toggleClient, setToggleClient] = useState("null");
  const [toggleLocation, setToggleLocation] = useState("null");
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);

  const [workperformedby, setWorkperformedby] = useState("null");

  const [lettertype, setLetterType] = useState("null");
  const [structureList, setstructureList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [error, setError] = useState(null);

  const [selectedNo, setNo] = useState("");
  const [selectedFromDate, setFromDate] = useState("null");
  const [selectedToDate, setToDate] = useState("null");
  const [structure, setStructure] = useState("null");
  const [sector, setSector] = useState("null");
  const [service, setService] = useState("null");
  const [selectedProject, setSelectedProject] = useState("null");

  const [trackRecordList, setTrackRecordList] = useState([]);

  const [buffer, setBuffering] = useState(false);
  const [bufferForProjectType, setbufferForProjectType] = useState(false);
  const [bufferForSubcompany, setbufferForSubcompany] = useState(false);

  const getcompany = async () => {
    setbufferForSubcompany(true); // Start Buffering
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
    } catch (err) {
      // handleErrorToast(err); // You can handle any general error here if needed
    } finally {
      setbufferForSubcompany(false); // End Buffering
    }
  };

  const getProjects = async () => {
    setBuffering(true); // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/certificatefilter/${toggleProjectType}/${toggleClient}/${selectedFromDate}/${selectedToDate}/${toggleCompany}/`,
      );
      setTrackRecordList(res.data);
    } catch (err) {
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getcompany();
  }, []);

  useEffect(() => {
    getProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedFromDate,
    selectedToDate,
    toggleProjectType,
    toggleClient,
    toggleCompany,
  ]);

  console.log("selectedFromDate");
  console.log(selectedFromDate);

  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleLocation, trackRecordList]);

  const applyFilters = () => {
    let filteredData = trackRecordList;
    if (toggleLocation !== "null") {
      filteredData = filteredData.filter((i) => i.length === toggleLocation);
    }

    setFilteredData(filteredData);
  };

  const [dataForFilter, setDataForFilter] = useState([]);
  const [clientForFilter, setClientForFilter] = useState([]);
  const [bufferForClient, setBufferForClient] = useState(false);

  const getDataForFilter = async () => {
    setbufferForProjectType(true);
    setBufferForClient(true);

    try {
      const res = await axios.get(`${BASE_URL}/siteproject/certificate/`);

      // Unique project_type
      const uniqueProjectTypes = [
        ...new Set(
          res.data
            .map((item) => item.project_type?.trim())
            .filter((type) => type && type !== ""),
        ),
      ]
        .sort((a, b) => a.localeCompare(b))
        .map((type) => ({ project_type: type }));

      setDataForFilter(uniqueProjectTypes);

      // Unique client
      const uniqueClients = [
        ...new Set(
          res.data
            .map((item) => item.client?.trim())
            .filter((client) => client && client !== ""),
        ),
      ]
        .sort((a, b) => a.localeCompare(b))
        .map((client) => ({ client: client }));

      setClientForFilter(uniqueClients);
    } catch (error) {
      console.error(error);
    } finally {
      setbufferForProjectType(false);
      setBufferForClient(false);
    }
  };

  useEffect(() => {
    getDataForFilter();
  }, []);

  const projectTypeData = [
    ...dataForFilter.map((i) => ({
      value: i.project_type,
      label: i.project_type,
    })),
  ];
  const clientData = [
    ...clientForFilter.map((i) => ({
      value: i.client,
      label: i.client,
    })),
  ];
  console.log("projectTypeData", clientForFilter);
  console.log(projectTypeData);

  const handleProjectTypeFilter = (option) => {
    if (!option) {
      setToggleProjectType("null");
      return;
    }
    setToggleProjectType(option.value);
  };
  const handleClientFilter = (option) => {
    if (!option) {
      setToggleClient("null");
      return;
    }
    setToggleClient(option.value);
  };

  console.log("dataForFilter");
  console.log(dataForFilter);
  const updateTrackRecord = (updatedItem) => {
    setTrackRecordList((prev) =>
      prev.map((item) => (item.id === updatedItem.id ? updatedItem : item)),
    );
  };

  const sortedStatesAndUTs = [...statesAndUTs].sort();

  const [location, setLocation] = useState([]);

  useEffect(() => {
    const uniqueLocations = [
      ...new Set(
        sortedStatesAndUTs
          .map((item) => item?.trim())
          .filter((type) => type && type !== ""),
      ),
    ]
      .sort((a, b) => a.localeCompare(b))
      .map((type) => ({ location: type }));

    setLocation(uniqueLocations);
  }, [statesAndUTs]);

  const StatesOptions = location
    ?.sort((a, b) => a.location.localeCompare(b.location))
    .map((i) => ({
      value: i.location,
      label: `${i.location}`,
    }));

  const handleStateFilter = (option) => {
    if (!option) {
      setToggleLocation("null");
      return;
    }
    setToggleLocation(option.value);
  };

  const [toggleState, setToggleState] = useState(1);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="attendance-history-cont">
        <div className="field-cont">
          <div className="attendance-subcontainer" style={{ width: "100%" }}>
            <div
              className="flex-row "
              style={{ width: "80%", flexWrap: "wrap" }}
            >
              <div title="Company Filter" className="field-cont-div">
                {bufferForSubcompany ? (
                  <div className="spinner-vsmall"></div>
                ) : (
                  <Office />
                )}
                <select
                  onChange={(e) => setToggleCompany(e.target.value)}
                  value={toggleCompany}
                  className="attendance-input-field width-15vw   date-field"
                >
                  <option value="null">Sub Company</option>
                  {siteSubCompanyList.map((company) => (
                    <option value={company.id}>{company.title}</option>
                  ))}
                  ;
                </select>

                <hr className="field-cont-hr" />
              </div>

              <div title="Project Type Filter" className="field-cont-div">
                {bufferForProjectType ? (
                  <div className="spinner-vsmall"></div>
                ) : (
                  <ProjectIcon />
                )}
                <Select
                  className="attendance-input-field  date-field"
                  options={projectTypeData}
                  value={
                    projectTypeData.find(
                      (item) => item.value === toggleProjectType,
                    ) || "null"
                  }
                  onChange={handleProjectTypeFilter}
                  isClearable
                  placeholder="Select Project-Type"
                  styles={CSSForFilterDropdown}
                />

                <hr className="field-cont-hr" />
              </div>
              <div title="State Filter" className="field-cont-div">
                {bufferForProjectType ? (
                  <div className="spinner-vsmall"></div>
                ) : (
                  <Location />
                )}
                <Select
                  className="attendance-input-field  date-field"
                  options={StatesOptions}
                  value={
                    StatesOptions.find(
                      (item) => item.value === toggleLocation,
                    ) || "null"
                  }
                  onChange={handleStateFilter}
                  isClearable
                  placeholder="Select Location"
                  styles={CSSForFilterDropdown}
                />

                <hr className="field-cont-hr" />
              </div>

              <div title="Client Filter" className="field-cont-div">
                {bufferForClient ? (
                  <div className="spinner-vsmall"></div>
                ) : (
                  <Employee />
                )}
                <Select
                  className="attendance-input-field  date-field"
                  options={clientData}
                  value={
                    clientData.find((item) => item.value === toggleClient) ||
                    "null"
                  }
                  onChange={handleClientFilter}
                  isClearable
                  placeholder="Select Client"
                  styles={CSSForFilterDropdown}
                />
                <hr className="field-cont-hr" />
              </div>

              <div title="Date Range Filter" className="field-cont-div ">
                <DateRangePicker
                  startDate={selectedFromDate}
                  endDate={selectedToDate}
                  placeHolder1="From Date"
                  placeHolder2="To Date"
                  onChange={(start, end) => {
                    setFromDate(start);
                    setToDate(end);
                  }}
                />
                <hr className="field-cont-hr" />
              </div>
            </div>
            <div className="flex-row">
              <Addformat
                getFormat={getProjects}
                siteSubCompanyList={siteSubCompanyList}
                toggleCompany={toggleCompany}
              />
              <UploadCompanyCredit
                getData={getProjects}
                subcompanyList={siteSubCompanyList}
              />
            </div>
          </div>
        </div>
        <div className="filter-showing " style={{ justifyContent: "end" }}>
          {/* <div>Letter Records:</div> */}

          <div>
            Showing {filteredData.length} of {filteredData.length}{" "}
          </div>
        </div>

        <div
          className="table-css-white-background  table-box paddingTop-0px scroll-container-table"
          style={{ minHeight: "380px" }}
        >
          <table ref={tableRef} className="table-css">
            <thead className="table-heading">
              <tr className="custom-table-head-tr">
                <th className="table-heading-text">S.no.</th>
                <th className="table-heading-text">Company Name</th>
                <th className="table-heading-text">Project Code</th>
                <th className="table-heading-text">Project Short Name </th>
                <th className="table-heading-text">Project Full Name </th>
                <th className="table-heading-text">Project Type</th>
                <th className="table-heading-text">State</th>
                <th className="table-heading-text">Completion Date</th>
                <th className="table-heading-text">Client</th>
                <th className="table-heading-text">Lane Type</th>
                <th className="table-heading-text">Total Length</th>
                <th className="table-heading-text">Total Cost</th>
                <th className="table-heading-text">Consultancy Fees</th>
                <th className="table-heading-text">Participate As</th>
                <th className="table-heading-text">
                  Is Share Mention on Client Certificate
                </th>
                <th className="table-heading-text">
                  Share as per Client Certificate
                </th>
                <th className="table-heading-text">
                  Is Share Mention on CA Certificate
                </th>
                <th className="table-heading-text">
                  Share as per CA Certificate
                </th>
                <th className="table-heading-text">Remarks</th>
                {sessionStorage.getItem("sitemanagement_role") === "BD" ? (
                  ""
                ) : (
                  <>
                    <th className="table-heading-text">Document Details</th>
                    <th className="table-heading-text">Edit</th>
                    <th className="table-heading-text">Delete</th>
                  </>
                )}
              </tr>
            </thead>
            {buffer ? (
              <div className="spinner-bgdatil"></div> //buffering logic
            ) : error ? (
              <p>Error fetching data: {error.message}</p>
            ) : (
              <tbody>
                {filteredData.map((i, index) => (
                  <tr className="custom-table-head-td">
                    <td className="table-body text-center">{index + 1}.</td>
                    <td className="table-body">
                      {i.sub_company_name ? i.sub_company_name : "-"}
                    </td>
                    <td className="table-body">
                      {i.project_code ? i.project_code : "-"}
                    </td>
                    <td className="table-body">
                      {i.project_short_name ? i.project_short_name : "-"}
                    </td>
                    <td className="table-body">
                      <div style={{ width: "200px", whiteSpace: "normal" }}>
                        {i.project_name ? i.project_name : "-"}
                      </div>
                    </td>
                    <td className="table-body">
                      {i.project_type ? i.project_type : "-"}
                    </td>
                    <td className="table-body">{i.length ? i.length : "-"}</td>

                    <td className="table-body text-center">
                      {i.completion_date ? formatDate(i.completion_date) : "-"}
                    </td>
                    <td className="table-body">{i.client ? i.client : "-"}</td>
                    <td className="table-body text-center">
                      {i.lane ? `${i.lane} Lane` : "-"}
                    </td>
                    <td className="table-body">
                      {i.project_length ? `${i.project_length}KM` : "-"}
                    </td>
                    <td className="table-body">
                      {i.project_cost_cr ? `₹ ${i.project_cost_cr} Cr` : "-"}
                    </td>
                    <td className="table-body">
                      {i.total_consultancy_fees_cr
                        ? `₹ ${i.total_consultancy_fees_cr} Cr`
                        : "-"}
                    </td>
                    <td className="table-body">
                      {i.participate_as ? i.participate_as : "-"}
                    </td>
                    <td className="table-body text-center">
                      {i.share_mention_on_clientcertificate ? "Yes" : "No"}
                    </td>
                    <td className="table-body text-center">
                      {i.share_asper_certificate
                        ? `${i.share_asper_certificate}%`
                        : "-"}
                    </td>
                    <td className="table-body text-center">
                      {i.CA_Certificate_available ? "Yes" : "No"}
                    </td>
                    <td className="table-body text-center">
                      {i.share_as_per_ca_certificate
                        ? `${i.share_as_per_ca_certificate}%`
                        : "-"}
                    </td>
                    <td className="table-body">
                      <div style={{ width: "100px", whiteSpace: "normal" }}>
                        {i.remark ? i.remark : "-"}
                      </div>
                    </td>

                    <td className="table-body text-center">
                      <DocumentModel
                        title="LOA & Certificate Document"
                        certificate={i.id}
                      />
                    </td>
                    <td className="table-body">
                      <UpdateFormat
                        i={i}
                        updateTrackRecord={updateTrackRecord} // <-- pass the new function
                        siteSubCompanyList={siteSubCompanyList}
                        toggleCompany={toggleCompany}
                      />
                    </td>
                    <td className="table-body">
                      <DeleteFormat i={i} getcertification={getProjects} />
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

export default CertificateFormat;
